module.exports = __webpack_public_path__ + "img/VP-UL-Profiles.ee2b5636.jpg";